import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import * as THREE from "three";
import { TweenLite } from "gsap";
import FadeInSection from "../blocks/Components/fadeinsection";
import { translate } from "../blocks/Components/translations";
import translations from "../blocks/Components/translations";

import InfiniteSlider from "../blocks/Components/infiniteslider";
import Project from "../blocks/Components/project";

// import SplashCursor from "../blocks/Animations/SplashCursor/SplashCursor";

const path = window.location.pathname;
const lang = path.startsWith("/en") ? "en" : "pt";

const Holder = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;

  @media (max-width: 1024px) {
  }
`;

const PageHolder = styled.div`
  width: 100%;
  max-width: 1512px;
  margin: 0 auto;
  position: relative;

  &.padding {
    padding: 24px;
  }

  &.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 1024px) {
    &.padding {
      padding: 0px;
    }
  }
`;

const Header = styled.div`
  position: ${(p) => (p.fixed ? "fixed" : "absolute")};
  mix-blend-mode: difference;
  width: 100%;
  max-width: 1512px;
  margin: 0 auto;
  left: 50%;
  top: ${(p) => (p.fixed ? "0" : `${p.top}px`)};
  transform: translate(-50%, 0);
  padding: 24px;

  background: transparent;
  z-index: 2;
  user-select: none;

  span {
    color: #ead7cc;
    font-family: Whyte;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: -0.4px;
  }

  @media (max-width: 1024px) {
    padding: 24px 16px;
  }
`;

const Content = styled.div`
  border-radius: 0px 0px 56px 56px;
  background: #000;
  position: relative;
  z-index: 1;

  padding-bottom: 171px;
  padding-top: 74px;

  @media (max-width: 1024px) {
    padding: 74px 16px 24px;
  }
`;

const Slider = styled.div`
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
  height: auto;
  position: relative;

  @media (max-width: 1024px) {
    height: 476px;
  }

  canvas {
    mix-blend-mode: lighten;
  }
`;

const Spacer = styled.div`
  height: 184px;
  clear: both;

  @media (max-width: 1024px) {
    height: 92px;
  }
`;

const IntroText = styled.div`
  color: #ead7cc;
  font-family: "Whyte Inktrap Regular";
  font-size: 56px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -1.12px;
  text-indent: 250px;

  @media (max-width: 1024px) {
    font-size: 32px;
    text-indent: 61px;
  }
`;

const ContentBlock = styled.div``;

const ContentTitle = styled.div`
  color: #ead7cc;
  font-family: "Whyte Inktrap Regular";
  font-size: 56px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -1.12px;
  text-indent: 250px;
  margin-bottom: 92px;
  position: relative;

  @media (max-width: 1024px) {
    font-size: 32px;
    text-indent: 61px;
  }
`;
const ContentTag = styled.span`
  display: inline-block;
  text-indent: 0px;
  border-radius: 20px;
  border: 1px solid #ead7cc;
  padding: 6px 16px;
  color: #ead7cc;
  font-family: Whyte;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 16px */
  letter-spacing: -0.32px;
  margin-right: 16px;
  top: -16px;
  position: relative;

  @media (max-width: 1024px) {
    top: -7px;
  }
`;

const ContentAbout = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 174px;

  p {
    color: #ead7cc;
    font-family: "Whyte";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 26px */
    letter-spacing: -0.4px;
  }

  img {
    width: 533px;
    height: 800px;
    border-radius: 16px;
    object-fit: cover;
  }

  video {
    width: 533px;
    height: 800px;
    border-radius: 16px;
    object-fit: cover;
  }

  @media (max-width: 1024px) {
    display: block;

    img {
      width: 100%;
      height: auto;
      margin-bottom: 56px;
    }
  }
`;

const ContentDoing = styled.div`
  display: flex;
  align-items: start;
  justify-content: right;
`;

const ContentDoingItems = styled.div`
  width: 100%;
  max-width: 881px;
`;

const ContentDoingItem = styled.div`
  border-top: 1px solid #212121;
  padding: 32px 0px;

  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    display: block;

    img {
      margin-bottom: 32px;
    }
  }
`;

const ImageCategory = styled.div`
  width: 120px;

  img {
    width: 100%;
  }
`;
const Text = styled.div`
  width: 100%;
  user-select: none;
  p {
    color: #ead7cc;
    font-family: Whyte;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -0.4px;

    span {
      color: #ead7cc;
      display: block;

      font-family: Whyte;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 130%; /* 26px */
      letter-spacing: -0.4px;
      margin-bottom: 24px;
    }
  }
`;
const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  align-items: start;
  justify-content: start;
  gap: 6px;
`;

const Tag = styled.div`
  flex: 1 1 auto;
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 20px;
  border: 1px solid #ead7cc;
  color: #ead7cc;
  font-family: Whyte;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 16px */
  letter-spacing: -0.32px;
  width: auto;
  flex: 0 1 auto;
  user-select: none;
`;

const ContentClients = styled.div`
  border-top: 1px solid rgba(234, 215, 204, 0.2);
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding-top: 40px;

  @media (max-width: 1024px) {
    display: block;
  }
`;

const ClientsTag = styled.div`
  color: #ead7cc;
  display: inline-flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: Whyte;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 16px */
  letter-spacing: -0.32px;
  border-radius: 20px;
  border: 1px solid #ead7cc;

  @media (max-width: 1024px) {
    margin-bottom: 56px;
  }
`;

const ContentClientsLogos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  max-width: 864px;

  @media (max-width: 1024px) {
    padding-bottom: 183px;
  }
`;

const ContentClientsLogosLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  gap: 120px;

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    justify-content: center;
    gap: 0px;
    /* padding: 0px 16px; */
  }
`;

const Footer = styled.div`
  z-index: 0;
  width: 100%;
  background: #ead7cc;
  position: fixed;
  /* max-width: 1512px; */
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
`;

const FooterLogo = styled.div`
  padding: 105px 60px 40px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;

  img {
    width: 80%;
  }
`;

const FooterBlocks = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;

  a.lastLink {
    margin-top: -4px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const FooterBlock = styled.div`
  width: fit-content;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: start;

  img.logo {
    margin-bottom: 16px;
  }

  span {
    color: #000;
    font-family: Whyte;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.4px;
  }

  a {
    color: #000;
    font-family: "Whyte Inktrap Regular";
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -1.12px;
    text-decoration: underline solid;
    margin-top: 16px;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #8b7d75;
    }
  }
`;

const Link = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  transition: color 0.3s ease-in-out;

  &.second {
    margin-top: -16px;
  }

  * {
    transition: color 0.3s ease-in-out;
  }

  &:hover * {
    color: #8b7d75;
  }
`;

const Arrow = styled.span`
  color: #000;
  font-family: "Whyte Inktrap";
  font-size: 56px !important;
  font-style: normal;
  font-weight: 400;
  margin-top: 0px;
  letter-spacing: -1.12px;
  margin-bottom: -40px;
`;

const Copy = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 24px 24px 12px;

  span {
    color: #000;
    font-family: Whyte;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.32px;

    &.top {
      cursor: pointer;
    }
  }

  @media (max-width: 1024px) {
    margin-top: 40px;
  }
`;

let SLIDER_IMAGES = [
  "/img/slide0.jpg",
  "/img/slide1.jpg",
  "/img/slide2.jpg",
  "/img/slide3.jpg",
  "/img/slide4.jpg",
  "/img/slide5.jpg",
  "/img/slide6.jpg",
  "/img/slide7.jpg",
  "/img/slide8.jpg",
  "/img/slide9.jpg",
  "/img/slide10.jpg",
];

if (window.innerWidth < 600) {
  SLIDER_IMAGES = [
    "/img/mobile/slide0.jpg",
    "/img/mobile/slide1.jpg",
    "/img/mobile/slide2.jpg",
    "/img/mobile/slide3.jpg",
    "/img/mobile/slide4.jpg",
    "/img/mobile/slide5.jpg",
    "/img/mobile/slide6.jpg",
    "/img/mobile/slide7.jpg",
    "/img/mobile/slide8.jpg",
    "/img/mobile/slide9.jpg",
    "/img/mobile/slide10.jpg",
  ];
}

function shuffleArray(array) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

function balanceProjects(projects) {
  // 1. Agrupa por tag
  const tagsMap = {};
  projects.forEach((p) => {
    if (!tagsMap[p.tag]) tagsMap[p.tag] = [];
    tagsMap[p.tag].push(p);
  });

  // 2. Em cada tag, separa vídeos e imagens e embaralha internamente
  const tagsBalanced = Object.entries(tagsMap).map(([tag, items]) => {
    const videos = shuffleArray(items.filter((i) => i.video));
    const images = shuffleArray(items.filter((i) => i.image));
    const mixed = [];

    while (videos.length || images.length) {
      if (videos.length) mixed.push(videos.pop());
      if (images.length) mixed.push(images.pop());
    }

    return shuffleArray(mixed); // novo embaralhamento interno
  });

  // 3. Intercala os grupos de tags
  const finalList = [];
  let index = 0;
  let hasItems = true;

  while (hasItems) {
    hasItems = false;

    for (const group of tagsBalanced) {
      if (group[index]) {
        finalList.push(group[index]);
        hasItems = true;
      }
    }

    index++;
  }

  return finalList;
}

const PROJECTS = balanceProjects(
  [
    {
      tag: "Experiências Digitais",
      text: "Escola de inteligência artificial de uma das principais comunidades de tecnologia e educação do Brasil.",
      image: null,
      video: "/projects/videos/tera02.mp4",
      width: 401,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Criação do universo expandido do livro, uma plataforma acessível via QR Code para aproximar leitores e histórias.",
      image: "/projects/images/aleph01.jpg",
      video: null,
      width: 381,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Criação do universo expandido do livro, uma plataforma acessível via QR Code para aproximar leitores e histórias.",
      image: null,
      video: "/projects/videos/aleph01.mp4",
      width: 381,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Criação do universo expandido do livro, uma plataforma acessível via QR Code para aproximar leitores e histórias.",
      image: null,
      video: "/projects/videos/aleph02.mp4",
      width: 381,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Criação do universo expandido do livro, uma plataforma acessível via QR Code para aproximar leitores e histórias.",
      image: null,
      video: "/projects/videos/aleph03.mp4",
      width: 381,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Plataforma de streaming gratuita com filmes dirigidos por pessoas LGBT ou com essa temática.",
      image: "/projects/images/lgbtflix01.jpg",
      video: null,
      width: 541,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Plataforma de streaming gratuita com filmes dirigidos por pessoas LGBT ou com essa temática.",
      image: "/projects/images/lgbtflix02.jpg",
      video: null,
      width: 541,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Plataforma de streaming gratuita com filmes dirigidos por pessoas LGBT ou com essa temática.",
      image: null,
      video: "/projects/videos/lgbtflix03.mp4",
      width: 541,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Portfólio digital para o Atelier Marko Brajovick, inspirado pela presença e formas do design em ecossistemas naturais.",
      image: "/projects/images/marko01.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Portfólio digital para o Atelier Marko Brajovick, inspirado pela presença e formas do design em ecossistemas naturais.",
      image: "/projects/images/marko02.jpg",
      video: null,
      width: 832,
      height: 676,
    },
    {
      tag: "Experiências Digitais",
      text: "Portfólio digital para o Atelier Marko Brajovick, inspirado pela presença e formas do design em ecossistemas naturais.",
      image: null,
      video: "/projects/videos/marko01.mp4",
      width: 676,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Experiência de boas-vindas para os visitantes da Casa Nubank Ultravioleta. Um tronco de madeira tecnológico apresenta diferentes modos de interação.",
      image: "/projects/images/ultravioleta01.jpg",
      video: null,
      width: 405,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Experiência de boas-vindas para os visitantes da Casa Nubank Ultravioleta. Um tronco de madeira tecnológico apresenta diferentes modos de interação.",
      image: "/projects/images/ultravioleta02.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Experiência de boas-vindas para os visitantes da Casa Nubank Ultravioleta. Um tronco de madeira tecnológico apresenta diferentes modos de interação.",
      image: null,
      video: "/projects/videos/ultravioleta01.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      image: "/projects/images/studio9201.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      image: "/projects/images/studio9202.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      image: "/projects/images/studio9203.jpg",
      video: null,
      width: 451,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      image: null,
      video: "/projects/videos/studio9201.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      image: null,
      video: "/projects/videos/studio9202.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Peça de arte, ambiente-interface programável de som, imagem, vídeo e luz que conta a história do objeto que emerge do centro.",
      image: "/projects/images/precioso01.jpg",
      video: null,
      width: 451,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Peça de arte, ambiente-interface programável de som, imagem, vídeo e luz que conta a história do objeto que emerge do centro.",
      image: "/projects/images/precioso02.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Peça de arte, ambiente-interface programável de som, imagem, vídeo e luz que conta a história do objeto que emerge do centro.",
      image: null,
      video: "/projects/videos/precioso01.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Luminária para ter em dupla: você a toca e o objeto acende na casa da outra pessoa.",
      image: "/projects/images/saudade01.jpg",
      video: null,
      width: 541,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Dispositivo que captura imagem e geolocalização de  exposição itinerante pelos rios da Amazônia e as transmite em uma experiência digital.",
      image: "/projects/images/araquem01.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Direção criativa, desenvolvimento e produção das salas da primeira arena de jogos interativos do Brasil.",
      image: null,
      video: "/projects/videos/pixel01.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Figital",
      text: "Direção criativa, desenvolvimento e produção das salas da primeira arena de jogos interativos do Brasil.",
      image: null,
      video: "/projects/videos/pixel02.mp4",
      width: 405,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Conceito, identidade visual e plataforma digital para a 28 edição do Festival em São Paulo.",
      image: "/projects/images/cultura01.jpg",
      video: null,
      width: 451,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Conceito, identidade visual e plataforma digital para a 28 edição do Festival em São Paulo.",
      image: "/projects/images/cultura02.jpg",
      video: null,
      width: 676,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Conceito, identidade visual e plataforma digital para a 28 edição do Festival em São Paulo.",
      image: "/projects/images/cultura03.jpg",
      video: null,
      width: 446,
      height: 676,
    },
    {
      tag: "Branding",
      text: "Conceito, identidade visual e plataforma digital para a 28 edição do Festival em São Paulo.",
      image: null,
      video: "/projects/videos/cultura01.mp4",
      width: 676,
      height: 676,
    },
  ].map((project) => {
    return {
      ...project,
      tag: translate(`tags.${normalizeKey(project.tag)}`, lang),
      text: translate(`project.${findProjectKey(project.text)}`, lang),
    };
  })
);

function normalizeKey(str) {
  const map = {
    "Experiências Digitais": "digital",
    Figital: "phygital",
    Branding: "branding",
  };
  return map[str] || str;
}

function findProjectKey(ptText) {
  const entries = Object.entries(translations.project || {});
  const entry = entries.find(([_, val]) => val.pt === ptText);
  return entry ? entry[0] : ptText;
}

export default function Home() {
  const [loaded, setLoaded] = useState(false);

  const divRef = useRef(null);
  const contentRef = useRef(null);
  const sliderRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [headerFixed, setHeaderFixed] = useState(true);
  const [headerAbsoluteTop, setHeaderAbsoluteTop] = useState(0);
  const [sliderHeight, setSliderHeight] = useState(
    window.innerWidth > 600 ? 680 : 480
  );

  useEffect(() => {
    const container = sliderRef.current;
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    const containerAspect = width / height;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    container.appendChild(renderer.domElement);

    const canvas = renderer.domElement;
    canvas.style.position = "absolute";
    canvas.style.top = "50%";
    canvas.style.left = "50%";
    canvas.style.transform = "translate(-50%, -50%)";
    canvas.style.width = "100%";
    canvas.style.height = "auto";

    const loader = new THREE.TextureLoader();
    const textures = [];
    const aspects = [];

    function initScene(textures, aspects) {
      let current = 0;
      const scene = new THREE.Scene();
      const camera = new THREE.OrthographicCamera(
        width / -2,
        width / 2,
        height / 2,
        height / -2,
        1,
        1000
      );
      camera.position.z = 1;

      const mat = new THREE.ShaderMaterial({
        uniforms: {
          dispFactor: { value: 0.0 },
          currentImage: { value: textures[0] },
          nextImage: { value: textures[1] },
          currentAspect: { value: aspects[0] },
          nextAspect: { value: aspects[1] },
          containerAspect: { value: containerAspect },
        },
        vertexShader: `
          varying vec2 vUv;
          void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }
        `,
        fragmentShader: `
          varying vec2 vUv;
          uniform sampler2D currentImage;
          uniform sampler2D nextImage;
          uniform float dispFactor;
          uniform float currentAspect;
          uniform float nextAspect;
          uniform float containerAspect;

          vec2 fitWidthUV(vec2 uv, float imgAsp, float contAsp) {
            float ratio   = contAsp / imgAsp;
            float inv     = 1.0 / ratio;
            float offsetY = (1.0 - inv) * 0.5;
            return vec2(uv.x, uv.y * inv + offsetY);
          }

          void main() {
            vec2 uv = vUv;
            float intensity = 0.3;
            vec4 o1 = texture2D(currentImage, uv);
            vec4 o2 = texture2D(nextImage,    uv);

            vec2 off1 = vec2(0.0, dispFactor    * (o2.r * intensity));
            vec2 off2 = vec2(0.0, (1.0 - dispFactor) * (o1.r * intensity));

            vec2 uvc = fitWidthUV(uv + off1, currentAspect,  containerAspect);
            vec2 uvn = fitWidthUV(uv + off2, nextAspect,     containerAspect);

            vec4 c = texture2D(currentImage, uvc);
            vec4 n = texture2D(nextImage,    uvn);

            gl_FragColor = mix(c, n, dispFactor);
          }
        `,
        transparent: true,
      });

      const geometry = new THREE.PlaneGeometry(width, height, 1);
      const mesh = new THREE.Mesh(geometry, mat);
      scene.add(mesh);

      const animate = () => {
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
      };
      animate();

      const transition = (toIndex) => {
        if (!textures[toIndex]) return;
        mat.uniforms.nextImage.value = textures[toIndex];
        mat.uniforms.nextAspect.value = aspects[toIndex];
        TweenLite.to(mat.uniforms.dispFactor, 1, {
          value: 1,
          ease: "expo.inOut",
          onComplete: () => {
            mat.uniforms.currentImage.value = textures[toIndex];
            mat.uniforms.currentAspect.value = aspects[toIndex];
            mat.uniforms.dispFactor.value = 0;
            current = toIndex;
          },
        });
      };

      container.addEventListener("click", () => {
        let rand;
        do {
          rand = Math.floor(Math.random() * (textures.length - 1)) + 1;
        } while (rand === current);
        transition(rand);
      });

      window.addEventListener("resize", () => {
        const w = container.offsetWidth;
        const h = container.offsetHeight;
        renderer.setSize(w, h);
        camera.left = w / -2;
        camera.right = w / 2;
        camera.top = h / 2;
        camera.bottom = h / -2;
        camera.updateProjectionMatrix();

        setSliderHeight(window.innerWidth > 600 ? 680 : 480);
      });
    }

    // 1) Preload da primeira imagem
    const firstImg = new Image();
    firstImg.src = SLIDER_IMAGES[0];
    firstImg.onload = () => {
      aspects[0] = firstImg.width / firstImg.height;
      loader.load(SLIDER_IMAGES[0], (tex0) => {
        textures[0] = tex0;
        initScene(textures, aspects);

        // 2) Lazy-load das demais
        SLIDER_IMAGES.slice(1).forEach((src, i) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            aspects[i + 1] = img.width / img.height;
            loader.load(src, (tex) => {
              textures[i + 1] = tex;
            });
          };
        });
      });
    };

    return () => {
      // opcional: limpar listeners
    };
  }, []);

  useEffect(() => {
    let fallbackTimeout;

    const onPageLoad = () => {
      clearTimeout(fallbackTimeout); // cancela o fallback se carregou a tempo

      requestAnimationFrame(() => {
        setLoaded(true);

        const container = sliderRef.current;
        if (container) {
          setTimeout(() => {
            container.click();
          }, 500);
        }
      });
    };

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);

      // // fallback: força carregamento após 5s
      // fallbackTimeout = setTimeout(() => {
      //   console.warn(
      //     "Fallback: página não carregou em 5s, liberando manualmente"
      //   );
      //   onPageLoad();
      // }, 5000);

      return () => {
        window.removeEventListener("load", onPageLoad);
        clearTimeout(fallbackTimeout);
      };
    }
  }, []);

  // Ajuste de footer height
  useEffect(() => {
    function updateHeight() {
      if (divRef.current)
        setHeight(divRef.current.getBoundingClientRect().height);
    }
    updateHeight();
    window.addEventListener("resize", updateHeight);
    window.addEventListener("load", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("load", updateHeight);
    };
  }, []);

  // Scroll header
  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;
      const { bottom } = contentRef.current.getBoundingClientRect();
      const shouldBeFixed = bottom > window.innerHeight;
      if (headerFixed && !shouldBeFixed)
        setHeaderAbsoluteTop(window.pageYOffset);
      setHeaderFixed(shouldBeFixed);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [headerFixed]);

  // Smooth scroll
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };
  function scrollToY(targetY = 0, duration = 700) {
    const startY = window.pageYOffset;
    const changeY = targetY - startY;
    let currentTime = 0;
    const animate = () => {
      currentTime += 16;
      const newY = easeInOutQuad(currentTime, startY, changeY, duration);
      window.scrollTo(0, newY);
      if (currentTime < duration) requestAnimationFrame(animate);
    };
    animate();
  }

  const videoRef = useRef(null);

  const stopVideo = () => {
    const video = videoRef.current;
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.style.display = "none"; // oculta vídeo

      requestAnimationFrame(() => {
        video.load(); // força reload
        video.style.display = "block"; // exibe novamente
      });
    }
  };

  const playVideo = () => {
    const video = videoRef.current;
    if (video) {
      video.play();
    }
  };

  return (
    <Holder className={`fade-container ${loaded ? "loaded" : ""}`}>
      {/* <SplashCursor /> */}
      <Header fixed={headerFixed} top={headerAbsoluteTop}>
        <PageHolder className="header">
          <span>{translate("header.name", lang)}</span>
          <img src="/img/logo_header.svg" alt="Fehra" />
        </PageHolder>
      </Header>
      <Content ref={contentRef} style={{ marginBottom: height - 56 }}>
        <PageHolder className="padding">
          <FadeInSection>
            <Slider style={{ height: sliderHeight }} ref={sliderRef} />
          </FadeInSection>
          <Spacer />
          <FadeInSection>
            <IntroText>{translate("intro.text", lang)}</IntroText>
          </FadeInSection>
          <Spacer />
          <FadeInSection>
            <InfiniteSlider speed={100}>
              {PROJECTS.map((project) => {
                return (
                  <Project
                    image={project.image}
                    video={project.video}
                    width={project.width}
                    height={project.height}
                    text={project.text}
                    tag={project.tag}
                  />
                );
              })}
            </InfiniteSlider>
          </FadeInSection>
          <Spacer />
          <ContentBlock>
            <FadeInSection>
              <ContentTitle>
                <ContentTag>{translate("about.title", lang)}</ContentTag>
                {translate("about.subtitle", lang)}
              </ContentTitle>
            </FadeInSection>
            <FadeInSection>
              <ContentAbout>
                <img src="/img/fehra.jpg" alt="Fehra" className="mobile" />
                <p>{translate("about.text", lang)}</p>
                <video
                  ref={videoRef}
                  className="desktop"
                  muted
                  playsInline
                  poster="/img/fehra.jpg"
                  preload="auto"
                  disablePictureInPicture
                  onMouseEnter={playVideo}
                  onMouseLeave={stopVideo}
                  onTouchStart={playVideo}
                  onTouchEnd={stopVideo}>
                  <source src="/video/fehra.mp4" type="video/mp4" />
                </video>
              </ContentAbout>
            </FadeInSection>
          </ContentBlock>
          <Spacer />
          <ContentBlock>
            <FadeInSection>
              <ContentTitle>
                <ContentTag>{translate("services.title", lang)}</ContentTag>
                {translate("services.description", lang)}
              </ContentTitle>
            </FadeInSection>
            <ContentDoing>
              <ContentDoingItems>
                <FadeInSection>
                  <ContentDoingItem>
                    <ImageCategory>
                      <img src="/img/cat1.svg" alt="Fehra" />
                    </ImageCategory>
                    <Text>
                      <p>
                        <span>{translate("services.digital.title", lang)}</span>
                        {translate("services.digital.text", lang)}
                      </p>
                      <Tags>
                        <Tag>{translate("tags.ux", lang)}</Tag>
                        <Tag>{translate("tags.interface", lang)}</Tag>
                        <Tag>{translate("tags.prototyping", lang)}</Tag>
                        <Tag>{translate("tags.motion", lang)}</Tag>
                        <Tag>{translate("tags.mobile", lang)}</Tag>
                        <Tag>{translate("tags.web", lang)}</Tag>
                        <Tag>{translate("tags.software", lang)}</Tag>
                        <Tag>{translate("tags.ai", lang)}</Tag>
                        <Tag>{translate("tags.frontend", lang)}</Tag>
                        <Tag>{translate("tags.backend", lang)}</Tag>
                      </Tags>
                    </Text>
                  </ContentDoingItem>
                </FadeInSection>
                <FadeInSection>
                  <ContentDoingItem>
                    <ImageCategory>
                      <img src="/img/cat2.svg" alt="Fehra" />
                    </ImageCategory>
                    <Text>
                      <p>
                        <span>
                          {translate("services.phygital.title", lang)}
                        </span>
                        {translate("services.phygital.text", lang)}
                      </p>
                      <Tags>
                        <Tag>{translate("tags.immersive", lang)}</Tag>
                        <Tag>{translate("tags.activation", lang)}</Tag>
                        <Tag>{translate("tags.installations", lang)}</Tag>
                        <Tag>{translate("tags.creative", lang)}</Tag>
                        <Tag>{translate("tags.interaction", lang)}</Tag>
                        <Tag>{translate("tags.smartObjects", lang)}</Tag>
                      </Tags>
                    </Text>
                  </ContentDoingItem>
                </FadeInSection>
                <FadeInSection>
                  <ContentDoingItem>
                    <ImageCategory>
                      <img src="/img/cat3.svg" alt="Fehra" />
                    </ImageCategory>
                    <Text>
                      <p>
                        <span>
                          {translate("services.consulting.title", lang)}
                        </span>
                        {translate("services.consulting.text", lang)}
                      </p>
                      <Tags>
                        <Tag>{translate("tags.productMgmt", lang)}</Tag>
                        <Tag>{translate("tags.productVision", lang)}</Tag>
                        <Tag>{translate("tags.mvp", lang)}</Tag>
                        <Tag>{translate("tags.sprint", lang)}</Tag>
                        <Tag>{translate("tags.serviceDesign", lang)}</Tag>
                        <Tag>{translate("tags.roadmap", lang)}</Tag>
                        <Tag>{translate("tags.research", lang)}</Tag>
                      </Tags>
                    </Text>
                  </ContentDoingItem>
                </FadeInSection>
                <FadeInSection>
                  <ContentDoingItem>
                    <ImageCategory>
                      <img src="/img/cat4.svg" alt="Fehra" />
                    </ImageCategory>
                    <Text>
                      <p>
                        <span>
                          {translate("services.branding.title", lang)}
                        </span>
                        {translate("services.branding.text", lang)}
                      </p>
                      <Tags>
                        <Tag>{translate("tags.visualId", lang)}</Tag>
                        <Tag>{translate("tags.brandStrategy", lang)}</Tag>
                        <Tag>{translate("tags.territory", lang)}</Tag>
                        <Tag>{translate("tags.logo", lang)}</Tag>
                        <Tag>{translate("tags.manual", lang)}</Tag>
                        <Tag>{translate("tags.visualSystem", lang)}</Tag>
                      </Tags>
                    </Text>
                  </ContentDoingItem>
                </FadeInSection>
              </ContentDoingItems>
            </ContentDoing>
            <ContentClients>
              <ClientsTag>{translate("clients.title", lang)}</ClientsTag>
              <div className="desktop">
                <ContentClientsLogos>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <img src="/img/c1.svg" alt="Nu Ultravioleta" />
                      <img src="/img/c2.svg" alt="Atelier Marko Brajovic" />
                      <img src="/img/c3.svg" alt="Cultura Inglesa" />
                      <img src="/img/c4.svg" alt="Tera" />
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <img src="/img/c5.svg" alt="Firjan" />
                      <img src="/img/c6.svg" alt="Comgas" />
                      <img src="/img/c7.svg" alt="Vote LGBT+" />
                      <img src="/img/c8.svg" alt="Daniela Kutschat" />
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <img src="/img/c9.svg" alt="DNDi" />
                      <img src="/img/c10.svg" alt="Freela School" />
                      <img src="/img/c11.svg" alt="Arena Pixel" />
                    </ContentClientsLogosLine>
                  </FadeInSection>
                </ContentClientsLogos>
              </div>
              <div className="mobile">
                <ContentClientsLogos>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c1.svg" alt="Nu Ultravioleta" />
                      </div>
                      <div>
                        <img src="/img/c2.svg" alt="Atelier Marko Brajovic" />
                      </div>
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c3.svg" alt="Cultura Inglesa" />
                      </div>
                      <div>
                        <img src="/img/c4.svg" alt="Tera" />
                      </div>
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c5.svg" alt="Firjan" />
                      </div>
                      <div>
                        <img src="/img/c6.svg" alt="Comgas" />
                      </div>
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c7.svg" alt="Vote LGBT+" />
                      </div>
                      <div>
                        <img src="/img/c8.svg" alt="Daniela Kutschat" />
                      </div>
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c9.svg" alt="DNDi" />
                      </div>
                      <div>
                        <img src="/img/c10.svg" alt="Freela School" />
                      </div>
                    </ContentClientsLogosLine>
                  </FadeInSection>
                  <FadeInSection>
                    <ContentClientsLogosLine>
                      <div>
                        <img src="/img/c11.svg" alt="Arena Pixel" />
                      </div>
                      <div />
                    </ContentClientsLogosLine>
                  </FadeInSection>
                </ContentClientsLogos>
              </div>
            </ContentClients>
          </ContentBlock>
        </PageHolder>
      </Content>
      <Footer ref={divRef}>
        <PageHolder>
          <FooterLogo>
            <img src="/img/fehra_footer.png" alt="Fehra" />
          </FooterLogo>
          <FooterBlocks>
            <FooterBlock>
              <img className="logo" src="/img/mini_logo.svg" alt="Fehra" />
              <span>Estúdio Fehra</span>
              <span>Rua General Jardim, 482 Cj 151</span>
              <span>01223-010, São Paulo</span>
            </FooterBlock>
            <FooterBlock>
              <span>{translate("footer.contactTitle", lang)}</span>
              <a href="mailto:alo@fehra.co">alo@fehra.co</a>
              <a href="https://wa.me/5511967309606" className="lastLink">
                Whatsapp
              </a>
            </FooterBlock>
            <FooterBlock>
              <span>{translate("footer.followUs", lang)}</span>
              <Link>
                <a
                  href="https://instagram.com/fehra______"
                  target="_blank"
                  rel="noreferrer">
                  Instagram
                </a>
                <Arrow>↗</Arrow>
              </Link>
              <Link className="second">
                <a
                  href="https://www.linkedin.com/company/fehra/"
                  target="_blank"
                  rel="noreferrer">
                  Linkedin
                </a>
                <Arrow>↗</Arrow>
              </Link>
            </FooterBlock>
          </FooterBlocks>
          <Copy>
            <span>{translate("footer.copyright", lang)}</span>
            <span className="top" onClick={() => scrollToY(0, 800)}>
              {translate("footer.backToTop", lang)}
            </span>
          </Copy>
        </PageHolder>
      </Footer>
    </Holder>
  );
}
